import * as React from "react"
import { gql } from "@apollo/client"
import { Button, Stack } from "@chakra-ui/react"
import { useRouter } from "next/router"

import { GetProfileStatsDocument, useCreatePostMutation } from "lib/graphql"
import { useForm } from "lib/hooks/useForm"
import { categoryMultiOptions, regionsIncNed } from "lib/static/filters"
import { postTypeOptions } from "lib/static/options"
import yup from "lib/yup"

import { DateInput } from "./DateInput"
import { Form } from "./Form"
import { FormError } from "./FormError"
import { Input } from "./Input"
import { MultiSelect } from "./MultiSelect"
import { Select } from "./Select"
import { Textarea } from "./Textarea"
import { useMe } from "lib/hooks/useMe"

const _ = gql`
  mutation CreatePost($data: CreatePostInput!) {
    createPost(data: $data) {
      ...PostDetail
    }
  }
`

const CreateSchema = yup.object().shape({
  title: yup.string().required("Verplicht"),
  description: yup.string().required("Verplicht"),
  videoUrl: yup.string().url().nullIfEmpty(),
  categories: yup.array().of(yup.string()).required("Verplicht"),
  region: yup.string().required("Verplicht"),
  type: yup.string().required("Verplicht"),
  deadline: yup.string().required("Verplicht"),
})

interface Props {
  refetch: () => void
}

export default function PostCreateForm({ refetch }: Props) {
  const { me } = useMe()
  const [createPost] = useCreatePostMutation()
  const router = useRouter()

  const defaultValues = {}

  const form = useForm({ defaultValues, schema: CreateSchema })

  const onSubmit = (values: any) => {
    if (!me) return
    return form.handler(
      () =>
        createPost({
          variables: { data: values },
          refetchQueries: [{ query: GetProfileStatsDocument, variables: { userId: me.id } }],
        }),
      {
        onSuccess: (res, toast) => {
          refetch()
          toast({ title: "Post gemaakt" })
          router.replace(`/prikbord/${res.createPost?.id}`)
        },
      },
    )
  }

  return (
    <Form onSubmit={onSubmit} {...form}>
      <Stack spacing={8}>
        <Input name="title" label="Titel" placeholder="Drummer op zoek naar een band" />
        <Textarea name="description" label="Beschrijving" />
        <Input name="videoUrl" label="Video Url" />
        <MultiSelect name="categories" label="Categorieën" options={categoryMultiOptions} />
        <Select name="region" label="Regio" options={regionsIncNed} />
        <Select name="type" label="Type" options={postTypeOptions} />
        <DateInput name="deadline" label="Deadline" />
        <Button colorScheme="yellow" type="submit" w="100%">
          Oproep maken
        </Button>
        <FormError />
      </Stack>
    </Form>
  )
}
